import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import globalMessages from 'translations/messages/global-messages';

function Text({ intl, title = '', size = 16, color = 'currentColor', ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ fill: 'none' }}
      {...props}
    >
      <title>{title ?? intl.formatMessage(globalMessages.text)}</title>
      <path
        d="M3.33398 5.73301V3.33301H8.00065M12.6673 5.73301V3.33301H8.00065M8.00065 3.33301V13.333M6.00065 13.333H10.0007"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
Text.propTypes = {
  intl: PropTypes.object.isRequired,
  title: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
};

export default injectIntl(Text);
